import type { GetProblemsQuery } from '../../../../shared/infra/queries.types';

export const filterProtocolCategoriesById = (
  protocols: GetProblemsQuery['protocolCategories'],
  id: string | undefined,
) => {
  return protocols.find((category: { id: string }) => category.id === id);
};
